import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";
import { Tab } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { S } from "./search.styles";

export const SearchView = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        navigate(`${newValue}${window.location.search}`);
    };

    return (
        <S.Tabs value={location.pathname} onChange={handleTabChange}>
            <Tab
                value="/next"
                icon={<ExploreOutlinedIcon fontSize="small" />}
                label={t("legacyNext.map", "map")}
                component={Link}
                to={`/next${window.location.search}`}
            />
            <Tab
                value="/next/list"
                icon={<SubjectOutlinedIcon fontSize="small" />}
                label={t("legacyNext.list", "list")}
                component={Link}
                to={`/next/list${window.location.search}`}
            />
            <Tab
                value="/next/graph"
                icon={<InsightsOutlinedIcon fontSize="small" />}
                label={t("legacyNext.graph", "graph")}
                component={Link}
                to={`/next/graph${window.location.search}`}
            />
        </S.Tabs>
    );
};
